var App = {};

jQuery(document).ready(function ($) {
    var self = null;

    App = {

        init: function () {
            self = this;
            this.initComponents();

        },

        initComponents: function () {
            Menu.init()
            SendFile.init()
            this.elemzesekSelectUser();
            this.openModal();

            if ($(".korabbi-elemzesek").length){
                this.getElemzes();
            }
        },

        elemzesekSelectUser: function () {
            $("#elemzesek-users").change(function () {
                $("#elemzesek-table").empty();
                let user = $(this).val();
                App.getElemzes(user);

            });
        },

        openModal: function () {
            $('.elemzesek-container').on('click', '.error-list', function () {
                $(".modal .modal__content").empty();
                $(".modal .modal-data .job-date").empty();

                let JobId = $(this).data("job-id");

                App.getKorabbiElemzesModal(JobId);

                MicroModal.show('error-modal');
            });
        },

        getElemzes: function (user) {
            $(document).ready(function () {
                let userId;

                if (!user) {
                    userId = $('.elemzesek-container').data("userid");
                } else {
                    userId = user;
                }

                let data = {
                    action: 'get_elemzesek',
                    userId: userId
                };

                $.ajax({
                    type: "POST",
                    url: ajax_url,
                    data: data,
                    dataType: 'JSON',
                    success: function (response) {
                        $(".elemzesek-container").empty();
                        $(".elemzesek-container").append(response.data);
                        $(".user-elemzesei span").empty();
                        $(".user-elemzesei span").append(response.username);
                    },
                    error: function (errorThrown) {
                        console.log(errorThrown);
                    }
                });
            })
        },

        getKorabbiElemzesModal: function (jobId) {

            let data = {
                action: 'get_korabbi_elemzesek_modal_content',
                jobId: jobId
            };

            $.ajax({
                type: "POST",
                url: ajax_url,
                data: data,
                dataType: 'JSON',
                success: function (response) {
                    $(".modal .modal__content").append(response.data);
                    $(".modal .modal-data .job-date").append(response.date);
                },
                error: function (errorThrown) {
                    console.log(errorThrown);
                }
            });
        }
    };

    App.init();
});
